import { SkiGameView } from "../VIEW/SkiGameView";
import { useAuth } from "../FIREBASE/useAuth";
import { displayName } from "../COMPONENTS/skigame/scores";

// Anyone can play; signing in puts your time on the shared leaderboard
function SkiGamePage() {
  const { user, loading } = useAuth();
  const player = user ? { uid: user.uid, name: displayName(user.displayName, user.email) } : null;
  return <SkiGameView player={player} authLoading={loading} />;
}

export default SkiGamePage;
